<div class="min-h-screen bg-white">
      <app-header [cartCount]="cartCount"></app-header>

      <!-- Hero Section -->
      <section class="relative py-20 bg-gradient-to-br from-orange-50 via-white to-red-50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center max-w-3xl mx-auto">
            <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Why <span class="text-orange-500">Capital Food</span>?
            </h1>
            <p class="text-xl text-gray-600 leading-relaxed">{{ companyInfo.tagline }}</p>
          </div>
        </div>
      </section>

      <!-- Story Section -->
      <section class="py-16">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
              <p class="text-gray-600 leading-relaxed mb-4">{{ companyInfo.description }}</p>
              <p class="text-gray-600 leading-relaxed mb-6">{{ companyInfo.mission }}</p>
              <p class="text-xl font-semibold text-orange-500">{{ companyInfo.motto }}</p>
            </div>
            <div class="grid grid-cols-2 gap-4">
              <div *ngFor="let restaurant of featuredRestaurants" class="rounded-2xl overflow-hidden shadow-lg">
                <img [src]="restaurant.image" [alt]="restaurant.name" class="w-full h-40 object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Features Grid -->
      <section class="py-16 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl font-bold text-gray-900 text-center mb-12">What Makes Us Different</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div *ngFor="let feature of features" class="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow duration-300">
              <div class="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-4">
                <lucide-icon [name]="feature.icon" class="w-7 h-7 text-orange-500"></lucide-icon>
              </div>
              <h3 class="text-xl font-bold text-gray-900 mb-2">{{ feature.title }}</h3>
              <p class="text-gray-600">{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Stats Section -->
      <section class="py-16">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <p class="text-4xl md:text-5xl font-bold text-orange-500">14</p>
              <p class="text-gray-600 mt-2">Restaurants</p>
            </div>
            <div>
              <p class="text-4xl md:text-5xl font-bold text-orange-500">7+</p>
              <p class="text-gray-600 mt-2">Cities</p>
            </div>
            <div>
              <p class="text-4xl md:text-5xl font-bold text-orange-500">1M+</p>
              <p class="text-gray-600 mt-2">Orders Delivered</p>
            </div>
            <div>
              <p class="text-4xl md:text-5xl font-bold text-orange-500">4.8</p>
              <p class="text-gray-600 mt-2">Average Rating</p>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section class="py-16 bg-gradient-to-r from-orange-500 to-red-500">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 class="text-3xl md:text-4xl font-bold text-white mb-6">Ready to Order?</h2>
          <p class="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Experience the best food delivery with Capital Food. 14 restaurants, unlimited savings!
          </p>
          <a routerLink="/" class="inline-flex items-center bg-white text-orange-500 hover:bg-gray-100 rounded-full px-8 py-4 text-lg font-semibold">
            Explore Restaurants
            <lucide-icon name="arrow-right" class="w-5 h-5 ml-2"></lucide-icon>
          </a>
        </div>
      </section>

      <app-footer></app-footer>
    </div>